import React, { Fragment, useRef } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Listing } from '@mummssoftware/utils/constants';
import { FormattedMessage } from 'react-intl';
import { getFontSize, getUpdatedClassName } from './utils';
import { PrintLabel } from './PrintLabels';
import { withSelectors } from './Selectors';
import messages from '../CertMessages';
import { FORM_NARRATIVE_ID } from '../../../constants';

const BasePrintFooter = withSelectors(({ physContainerRef, PhysPicker }) => (
  <Grid container direction="row" spacing={1} style={{ marginTop: 10 }}>
    <PrintLabel
      ref={physContainerRef}
      label={<FormattedMessage {...messages.NAME} />}
      sm
    >
      {PhysPicker}
    </PrintLabel>
    <PrintLabel label={<FormattedMessage {...messages.SIGNATURE} />} sm />
    <PrintLabel label={<FormattedMessage {...messages.DATE} />} sm={3} />
  </Grid>
));

const PrintFooter = ({ alreadyCertified }) => {
  const physContainerRef = useRef(null);
  return (
    <BasePrintFooter
      absolutePhysPicker
      physSelectorId="picker-footer"
      alreadyCertified={alreadyCertified}
      dataPickerHeight="50%"
      physContainerRef={physContainerRef}
      disablePhysPicker
    />
  );
};
export const CertFooter = ({
  classes,
  alreadyCertified,
  footer,
  formNarrativeId,
  certificationDateTime,
  phys,
  updates,
  smallWidget,
  trailingMessage,
  printConfig,
  historicalView,
}) => (
  <Fragment>
    {
      {
        print: <PrintFooter alreadyCertified={alreadyCertified} />,
        certified: (
          <Fragment>
            <Typography
              className={getUpdatedClassName(
                classes,
                updates,
                FORM_NARRATIVE_ID,
              )}
              style={{ fontSize: getFontSize(smallWidget, historicalView) }}
              paragraph
            >
              {
                formNarrativeId ? (
                  /* eslint-disable indent */
                  <FormattedMessage
                    {...messages.electronicallySigned}
                    values={{ phys, certificationDateTime }}
                  />
                ) : (
                  ''
                )
                /* eslint-enable */
              }
            </Typography>
            {printConfig && printConfig.view === Listing && !formNarrativeId && (
              <Typography
                className={getUpdatedClassName(
                  classes,
                  updates,
                  FORM_NARRATIVE_ID,
                )}
                style={{ fontSize: getFontSize(smallWidget, historicalView) }}
                paragraph
              >
                {trailingMessage}
              </Typography>
            )}
          </Fragment>
        ),
        default: null,
      }[footer]
    }
  </Fragment>
);
